/* unplugin-vue-components disabled */import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/FileVideoUpload.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "mine-cell",
    class: {
      border: !_vm.hiddenBorder
    }
  }, [!_vm.hasTitleSlot ? _c('div', [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _vm.hasTitleSlot ? _c('div', [_vm._t("title")], 2) : _vm._e(), _vm.showUpload ? _vm._l(_vm.imgUrlsForPreviewer, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "uploaded"
    }, [_c('div', {
      staticClass: "uploaded-body"
    }, [_c('div', {
      staticClass: "uploaded-list",
      on: {
        "click": function ($event) {
          return _vm.show(index);
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": "/spa_static_mobile/icon/zip89_87@3x.png"
      }
    })]), _c('div', {
      staticClass: "uploaded-name"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])]), _c('div', {
      staticClass: "uploaded-list-delete",
      on: {
        "click": function ($event) {
          return _vm.deleteImg(index);
        }
      }
    }, [_c('icon', {
      attrs: {
        "type": "clear"
      }
    })], 1)]);
  }) : _vm._e(), _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "upload-list upload-btn"
  }, [_vm.isUpperLimit ? _c('div', {
    staticClass: "file-input limit",
    on: {
      "click": _vm.clickUpload
    }
  }) : _vm._e(), _c(__unplugin_components_0, {
    attrs: {
      "target": _vm.realtarget,
      "oss": _vm.oss,
      "action": "POST"
    },
    on: {
      "start": _vm.start,
      "finish": _vm.finish,
      "progress": function ($event) {
        _vm.progress = $event;
      }
    }
  })], 1)]), _c('Loading', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    attrs: {
      "text": _vm.progress + '%'
    },
    model: {
      value: _vm.loadingShow,
      callback: function ($$v) {
        _vm.loadingShow = $$v;
      },
      expression: "loadingShow"
    }
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };